module.exports = __webpack_public_path__ + "static/img/14.0ec69ebc.gif";